import './Footer.css';

const INSTAGRAM = 'https://instagram.com/zairecolor';
// const EMAIL = 'admin@zairecolor.com';

function Footer() {
    const year = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer-inner">
                {/* <span className="footer-name">ZaireColor</span> */}
                <div className="footer-links">
                    {/* <a href={`mailto:${EMAIL}`}>{EMAIL}</a> */}
                    {/* <a href={INSTAGRAM} target="_blank" rel="noopener noreferrer">
                        Instagram
                    </a> */}
                </div>
                <span className="footer-copy">&copy; {year} ZaireColor</span>
                <span className="footer-credit">
                    {'site by '}
                    <a href="https://github.com/dgelok" target="_blank" rel="noopener noreferrer">
                        GelokDev
                    </a>
                </span>
            </div>
        </footer>
    );
}

export default Footer;
